import {Routes} from '@angular/router';

export const regionManagementRoutes: Routes = [
  {
    path: 'regionManagement',
    loadComponent: () => import('./region-management.component').then(m => m.RegionManagementComponent),
    data: {title: '区域管理'},
  },
  {
    path: 'areaManagement',
    loadComponent: () => import('./area-management/area-management.component').then(m => m.AreaManagementComponent),
    data: {title: '片区管理'},
  },
  {
    path: 'areaManagement/add',
    loadComponent: () => import('./area-management/add-area/add-area.component').then(m => m.AddAreaComponent),
    data: {title: '新增片区'},
  },
  {
    path: 'areaManagement/:id',
    loadComponent: () => import('./area-management/add-area/add-area.component').then(m => m.AddAreaComponent),
    data: {title: '编辑片区'},
  },
  {
    path: 'areaDeliveryerManagement',
    loadComponent: () => import('./area-deliveryer-management/area-deliveryer-management.component').then(m => m.AreaDeliveryerManagementComponent),
    data: {title: '片区配送员管理'},
  },
  {
    path: 'areaDeliveryerManagement/add',
    loadComponent: () => import('./area-deliveryer-management/add-deliveryer/add-deliveryer.component').then(m => m.AddDeliveryerComponent),
    data: {title: '新增配送员'},
  },
  {
    path: 'areaDeliveryerManagement/:id',
    loadComponent: () => import('./area-deliveryer-management/add-deliveryer/add-deliveryer.component').then(m => m.AddDeliveryerComponent),
    data: {title: '编辑配送员'},
  },
  {
    path: 'areaDeliveryFeeManagement',
    loadComponent: () => import('./area-delivery-fee-management/area-delivery-fee-management.component').then(m => m.AreaDeliveryFeeManagementComponent),
    data: {title: '片区配送费管理'},
  },
  {
    path: 'areaDeliveryFeeManagement/add',
    loadComponent: () => import('./area-delivery-fee-management/add-delivery-fee/add-delivery-fee.component').then(m => m.AddDeliveryFeeComponent),
    data: {title: '新增配送费'},
  },
];
